import React from 'react';
import { tokens as defaultTokens } from '../tokens';

export default function MetaLabel({ children, tokens = defaultTokens, style }) {
  return (
    <div style={{
      fontFamily: tokens.fontBody, fontSize: tokens.meta + 1,
      letterSpacing: '0.14em', fontWeight: 500,
      textTransform: 'uppercase', color: tokens.textLow, ...style,
    }}>{children}</div>
  );
}
